import React from 'react';
import { Box, Spacer, Typography, Image, useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { ModalLocal } from '@components';
import { modals } from '@modals';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { Call } from '@bcp-nextgen-dx-component-factory/accolade-design-system/dist/assets/MBCP/icons';
import { rem } from '@helpers';
/* cspell: disable */
export const WaitingForCall: React.FC = () => {
	const t = useTranslation();
	const { palette } = useTheme();
	return (
		<ModalLocal
			name={modals.waitingForCall}
			middleContent={{
				content: (
					<Box
						styles={{
							flexDirection: 'column',
							alignItems: 'center',
							width: '100%',
						}}
					>
						<Image
							source={Call}
							svgProps={{
								fill: palette.primary.p1,
								width: rem(72),
								height: rem(72),
							}}
						/>
						<Spacer vertical={24} />
						<Typography appearance="subtitle-200-02">{t('modals.waitingForCall.title')}</Typography>
						<Spacer vertical={4} />
						<Typography appearance="body-100-02">{t('modals.waitingForCall.subtitle')}</Typography>
					</Box>
				),
				type: 'custom',
			}}
		/>
	);
};
